/** 같은 DOM subtree를 옮긴다. 지원 브라우저는 연결 상태도 보존하고, 나머지는 동일 노드로 fallback한다. */
export function moveStableRoot(root: HTMLElement, target: HTMLElement) {
  if (root.parentNode === target) return;
  const destination = target as HTMLElement & {
    moveBefore?: (node: Node, before: Node | null) => void;
  };
  if (
    root.isConnected &&
    target.isConnected &&
    root.ownerDocument === target.ownerDocument &&
    destination.moveBefore
  ) {
    try {
      destination.moveBefore(root, null);
      return;
    } catch {
      // 연결 상태가 commit 중 바뀌어도 React/DOM identity는 유지한다.
    }
  }
  target.appendChild(root);
}
